<tt-button
    ttText="orderhead_convert_to_order"
    [ttType]="type"
    [ttIcon]="icon"
    [ttTextAlign]="textAlign"
    [ttIconAlign]="iconAlign"
    (ttClick)="convert()"
    [ttDisabled]="converting"
    [ttLoading]="converting"
></tt-button>
